module.exports = "./static/empty-icon.bb3a5ccc.png";